import { mapGetters } from "vuex";
import { globalLoader } from "@/helpers/variables";

export default {
  name: "ProAgeBanner",
  props: {},
  emits: [],
  components: {},
  setup() {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {
    ...mapGetters({
      content: "proAge/content",
    }),
  },
  methods: {
    onBannerLoad() {
      globalLoader(false);
    },
    scroll() {
      const element = document.querySelector(".pro-age__format--title");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
          offset: { top: 30 },
        });
      }
    },
  },
};
